// if (!customElements.get('product-modal')) {
//     customElements.define('product-modal', class ProductModal extends ModalDialog {
//         constructor() {
//             super()
//         }
//         hide() {
//             super.hide()
//         }
//         show(opener) {
//             super.show(opener);
//             this.showActiveMedia()
//         }
//         showActiveMedia() {
//             this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach((element) => {
//                 element.classList.remove('active')
//             });
//             const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
//             const activeMediaTemplate = activeMedia.querySelector('template');
//             const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
//             activeMedia.classList.add('active');
//             activeMedia.scrollIntoView();
//             const container = this.querySelector('[role="document"]');
//             container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
//             if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
//                 activeMedia.loadContent();
//         }
//     })
// }

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    
    hide() {
      super.hide();
    }
    
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
    
    showActiveMedia() {
        // Get the current media ID from the modal opener or modal itself
        let currentMediaId = this.openedBy?.getAttribute('data-current-media') || 
                            this.getAttribute('data-current-media');
        
        // Fallback to the opener's data-media-id if still not found
        if (!currentMediaId && this.openedBy) {
            currentMediaId = this.openedBy.getAttribute('data-media-id');
        }
        
        if (!currentMediaId) {
            console.warn('No current media ID found');
            return;
        }
        
        // Find all media elements and remove active class
        this.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('active');
        });
        
        // Find and activate the current media
        const activeMedia = this.querySelector(`[data-media-id="${currentMediaId}"]`);
        if (!activeMedia) {
            console.warn(`Media with ID ${currentMediaId} not found in modal`);
            return;
        }
        
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        
        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.width) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }
        
        // Initialize custom modal gallery if it exists
        this.initializeCustomModalGallery(currentMediaId);
        
        // Initialize zoom in modal after a short delay
        setTimeout(() => {
            this.initModalZoom();
        }, 100);
        
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
            activeMedia.loadContent();
        }
    }

    // Add this new method for modal zoom
    initModalZoom() {
        const modalImages = this.querySelectorAll('.main-image');
        if (modalImages.length === 0) return;
        
        modalImages.forEach(img => {
            img.style.cursor = 'zoom-in';
            img.addEventListener('click', function() {
                this.style.transform = this.style.transform === 'scale(2)' ? 'scale(1)' : 'scale(2)';
                this.style.cursor = this.style.transform === 'scale(2)' ? 'zoom-out' : 'zoom-in';
            });
        });
    }
    
    initializeCustomModalGallery(currentMediaId) {
      // Initialize your custom modal gallery with the current media
      const modalThumbs = this.querySelectorAll('.modal-thumbs img.thumb');
      const galleryImages = this.querySelectorAll('.gallery-image');
      
      if (modalThumbs.length === 0 || galleryImages.length === 0) {
        return; // Custom modal gallery not present
      }
      
      // Find the index of the current media
      let currentIndex = 0;
      modalThumbs.forEach((thumb, index) => {
        if (thumb.getAttribute('data-media-id') === currentMediaId) {
          currentIndex = index;
        }
      });
      
      // Show the correct image in the custom modal
      this.showCustomModalImage(currentIndex);
    }
    
    showCustomModalImage(index) {
      const slider = this.querySelector('.gallery-slider');
      const thumbs = this.querySelectorAll('.modal-thumbs img.thumb');
      const images = this.querySelectorAll('.gallery-image');
      
      if (!slider || thumbs.length === 0 || images.length === 0) {
        return;
      }
      
      // Update slider position
      slider.style.transform = `translateX(-${index * 100}%)`;
      
      // Update thumbnails
      thumbs.forEach(thumb => thumb.classList.remove('active'));
      if (thumbs[index]) {
        thumbs[index].classList.add('active');
        // Scroll thumbnail into view
        thumbs[index].scrollIntoView({ behavior: 'smooth', inline: 'center' });
      }
    }
  });
}